module.exports = __webpack_public_path__ + "static/Datamaran-a120da9c009e391f3037bd39f08f4f26.jpg";